import { AxiosResponse } from "axios";
import { EEPlanObjective } from "../../../../Model/Dto/EmploymentEquity/Plan/EEObjective"
import { axiosCoreInstance } from "../../../AxiosCoreInterceptor";
import * as ApiUrls from "./ApiUrl.Objectives";

export const ObjectivesService = {

    GetYears: (scorecardId: string): Promise<AxiosResponse<EEPlanObjective.YearDtoIn[]>> => 
        axiosCoreInstance.get(ApiUrls.GetObjectiveYears, {params:{scorecardId:scorecardId}}),
    GetObjective: (id: string): Promise<AxiosResponse<EEPlanObjective.DtoIn>> => axiosCoreInstance.get(`${ApiUrls.Objectives}/${id}`),
    CreateObjective: (objective: EEPlanObjective.DtoOut): Promise<AxiosResponse<EEPlanObjective.DtoIn>> => axiosCoreInstance.post(ApiUrls.Objectives, objective),
    UpdateObjective: (objective: EEPlanObjective.DtoOut): Promise<AxiosResponse<EEPlanObjective.DtoIn>> => axiosCoreInstance.put(ApiUrls.Objectives, objective),
    DeleteObjective: (id: string): Promise<AxiosResponse<void>> => axiosCoreInstance.delete(`${ApiUrls.Objectives}/${id}`),
    SearchObjectives: (searchRequest: EEPlanObjective.SearchRequest):
        Promise<AxiosResponse<EEPlanObjective.SearchResponse>> =>
        axiosCoreInstance.post(ApiUrls.SearchObjectives, searchRequest),

}


